import React from 'react';
import { EmptyState } from "@dev/ee-components";
import { useTranslation } from "react-i18next";
import { FormPublishUnavailableMessage } from './styles';

export const FormPublishUnavailable = (): JSX.Element => {
    const { t } = useTranslation();
    return <EmptyState text={<FormPublishUnavailableMessage>{t('nodatatodisplay')}<br />{t('noformpublishlinks')}</FormPublishUnavailableMessage>} />;
};
